import { createBundle } from 'widget/Common';
import { openCardText, oldOpenCardTextName } from 'utils/constants';
import Stores from 'config/Stores';

// ---- register 模块 ----
import RegisterView from 'bundle-loader?lazy&name=RegisterView!pages/Register/RegisterView';
import PhysicalCardView from 'bundle-loader?lazy&name=PhysicalCardView!pages/Register/PhysicalCard/PhysicalCardView';
import MemCardMsgView from 'bundle-loader?lazy&name=MemCardMsgView!pages/Register/MemCardMsg/MemCardMsgView';
import MemCardBasticMsgView from 'bundle-loader?lazy&name=MemCardMsgView!pages/Register/MemCardBasticMsg/MemCardBasticMsgView';
import MemGiftbagView from 'bundle-loader?lazy&name=MemGiftbagView!pages/Register/MemGiftbag/MemGiftbagView';
import RegisterStoreView from 'bundle-loader?lazy&name=RegisterStoreView!pages/Register/RegisterStore/RegisterStoreView';
import StoreCardMsgView from 'bundle-loader?lazy&name=StoreCardMsgView!pages/Register/StoreCardMsg/StoreCardMsgView';
import StudioMsgView from 'bundle-loader?lazy&name=StudioMsgView!pages/Register/StudioMsg/StudioMsgView';
import StoreLicenseView from 'bundle-loader?lazy&name=StoreLicenseView!pages/Register/StoreLicense/StoreLicenseView';
import StoreGiftbagView from 'bundle-loader?lazy&name=StoreGiftbagView!pages/Register/StoreGiftbag/StoreGiftbagView';
import BankSearchView from 'bundle-loader?lazy&name=BankSearchView!pages/Register/BankSearch/BankSearchView';
import ViewPackageView from 'bundle-loader?lazy&name=ViewPackageView!pages/Register/ViewPackage/ViewPackageView';
import StoreRenewalView from 'bundle-loader?lazy&name=StoreRenewalView!pages/Register/StoreRenewal/StoreRenewalView';
import SelectStoreTypeView from 'bundle-loader?lazy&name=ViewPackageView!pages/Register/SelectStoreType/SelectStoreTypeView';
import ApplyPartnerView from 'bundle-loader?lazy&name=ApplyPartnerView!pages/Register/ApplyPartner/index';
import ReadContract from 'bundle-loader?lazy&name=ReadContract!pages/Register/ReadContract/index';

const RouterConfig = [
  // ----- 注册 -----
  {
    path: '/register',
    title: '注册',
    component: () => {
      return createBundle(RegisterView);
    }
  },
  {
    path: '/register/physicalCard',
    title: '注册',
    component: () => {
      return createBundle(PhysicalCardView);
    }
  },
  {
    path: '/register/memCardMsg',
    title: `${Stores.AppMod.userInfo && Stores.AppMod.userInfo.memberRetail ? openCardText : oldOpenCardTextName}`,
    component: () => {
      return createBundle(MemCardMsgView);
    }
  },
  {
    path: '/register/MemCardBasticMsg',
    title: `${Stores.AppMod.userInfo && Stores.AppMod.userInfo.memberRetail ? openCardText : oldOpenCardTextName}`,
    component: () => {
      return createBundle(MemCardBasticMsgView);
    }
  },
  {
    //升级也是进入礼包选购页面，不能控制路由，否则注册开店都走不进去
    path: '/register/memGiftbag',
    title: '升级下单',
    component: () => {
      return createBundle(MemGiftbagView);
    }
  },
  {
    //本身申请开店是要进行路由权限控制的，但是店铺登录的注册店铺也是走这个页面，所以直走入口
    path: '/register/registerStore',
    title: '注册店铺',
    component: () => {
      return createBundle(RegisterStoreView);
    }
  },
  {
    path: '/register/storeCardMsg',
    title: '未注册会员申请开店',
    component: () => {
      return createBundle(StoreCardMsgView);
    }
  },
  {
    path: '/register/studioMsg',
    title: '申请开店',
    component: () => {
      return createBundle(StudioMsgView);
    }
  },
  {
    path: '/register/storeLicense',
    title: '店铺证照',
    component: () => {
      return createBundle(StoreLicenseView);
    }
  },
  {
    path: '/register/storeGiftbag',
    title: '开店礼包选购',
    component: () => {
      return createBundle(StoreGiftbagView);
    }
  },
  {
    path: '/register/storeRenewal',
    title: '合同续签',
    component: () => {
      return createBundle(StoreRenewalView);
    }
  },

  {
    path: '/register/bankSearch',
    title: '支行搜索',
    component: () => {
      return createBundle(BankSearchView);
    }
  },
  {
    path: '/register/ViewPackage',
    title: '预览套餐',
    component: () => {
      return createBundle(ViewPackageView);
    }
  },
  {
    path: '/register/selectStoreType',
    title: '开店-选择店铺类型',
    component: () => {
      return createBundle(SelectStoreTypeView);
    }
  },
  {
    path: '/register/applyPartner',
    title: '申请合伙人',
    component: () => {
      return createBundle(ApplyPartnerView);
    }
  },
  {
    path: '/register/readContract',
    title: '阅读合同',
    component: () => {
      return createBundle(ReadContract);
    }
  }
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Register/RouterConfig.js